import React from "react";
import "./index.css";

export default function Background() {
  return (
     <section className="section">
      <div className="sectionTitle">BACKGROUND</div>
      <div className="sectionContent">
        <p>
         Writing is my part of life, started with writing quotations, poetries, and songs, and now I'm writing code.
        </p>
        <p>Writing something is never easy, you have to read, and learn new things . 
</p>
        <p>
         I'm a Front end developer and currently learning Redux having made many projects using HTML, CSS, Javascript, and React.</p>
        <p>
        <p>I also started Podcast for self-development by talking to people from different industries. It has listened to over 28000+ . Got also millions of views on my songs. 

        </p>
          <strong>When I'm not in front of a computer screen</strong>, I'm
          probably reading books, writing or watching movies.
        </p>
      </div>
    </section>
  );
}